/**
 * Where the shop-wide in-app-browser banner shows. Every shop page — home,
 * canvas, wall-art, art, calendar, paketi, photography, zemljevid, the design
 * pages, order steps — because customers land from ads on all of them and the
 * banner used to be on the home page only. Left out:
 *  - the delivery step, which shows its own inline, non-dismissable notice
 *    above the pay button instead (no second banner);
 *  - the order summary, the Stripe success page and the cash-on-delivery
 *    confirmation (payment-on-delivery): the order is placed, nothing is left
 *    to upload or pay;
 *  - the party camera guest/host pages (dogodki, /e/), a separate product
 *    with its own flow, and the /dev previews.
 * Admin lives outside [locale] and never mounts it.
 */
const EXCLUDED = [
  /^\/[^/]+\/order\/[^/]+\/(delivery|summary|payment-on-delivery)(\/|$)/,
  /^\/[^/]+\/(success|dogodki|e|dev)(\/|$)/,
  /^\/admin(\/|$)/,
];

export function showsShopInAppNotice(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return !EXCLUDED.some((re) => re.test(pathname));
}
